/* tslint:disable */
/* eslint-disable */

import React, { CSSProperties, SVGAttributes, FunctionComponent } from 'react';
import { getIconColor } from './helper';

interface Props extends Omit<SVGAttributes<SVGElement>, 'color'> {
  size?: number;
  color?: string | string[];
}

const DEFAULT_STYLE: CSSProperties = {
  display: 'block',
};

const IconPiaoleijiantou: FunctionComponent<Props> = ({ size, color, style: _style, ...rest }) => {
  const style = _style ? { ...DEFAULT_STYLE, ..._style } : DEFAULT_STYLE;

  return (
    <svg viewBox="0 0 1536 1024" width={size + 'px'} height={size + 'px'} style={style} {...rest}>
      <path
        d="M153.6 204.8l512 682.666667a128 128 0 0 0 204.8 0l512-682.666667A128 128 0 0 0 1280 0h-1024a128 128 0 0 0-102.4 204.8z"
        fill={getIconColor(color, 0, '#A78627')}
      />
    </svg>
  );
};

IconPiaoleijiantou.defaultProps = {
  size: 18,
};

export default IconPiaoleijiantou;
